/**
 * @Store
 */

import Vue from 'vue/dist/vue';
import Vuex from 'vuex';
import numberFormat from 'js/lib/numberFormat';

export const eventBus = new Vue();

Vue.filter('price', function(value) {
  return `${numberFormat(value, ' ', '.')} ₽`;
});

Vue.use(Vuex);

const url = '/cart';

const state = {
  products: [],
  ready: false
};

const mutations = {
  ADD_PRODUCT(state, products) {
    state.products.push(...products);
  },
  REMOVE_PRODUCT(state, id) {
    state.products = state.products.filter(product => product.id !== id);
  },
  UPDATE_AMOUNT(state, { id, amount }) {
    state.products.map(product => {
      if (product.id === id) {
        product.amount = amount;
      }
    });
  }
};

const actions = {
  addProduct(context, data) {
    return $
      .ajax({
        type: 'POST',
        url,
        data
      })
      .done(product => {
        context.commit('ADD_PRODUCT', [product]);
        eventBus.$emit('product.add', { id: product.id });
        return product;
      })
      .fail(() => {
        return new Error();
      });
  },
  updateAmount(context, { id, amount }) {
    $.ajax({
      type: 'PATCH',
      url,
      data: {
        id,
        amount
      }
    });

    context.commit('UPDATE_AMOUNT', { id, amount });
    eventBus.$emit('product.amount.change', { id, amount });
  },
  removeProduct(context, id) {
    $.ajax({
      url,
      type: 'DELETE',
      data: {
        id
      }
    });
    context.commit('REMOVE_PRODUCT', id);
    eventBus.$emit('product.remove', { id });
  },
  syncProductsList(context) {
    return $
      .ajax({
        url: `${url}/sync`,
        type: 'GET'
      })
      .done(products => {
        context.commit('ADD_PRODUCT', products);
        state.ready = true;
        eventBus.$emit('product.synced');
      })
      .fail(() => {
        throw new Error();
      });
  },
  getProduct(context, id) {
    return context.state.products.filter(product => {
      return Number(product.id) === id;
    });
  }
};

const getters = {
  productsAmount: state => {
    return state.products.length;
  }
};

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});

store.dispatch('syncProductsList');

export default store;
